<template>
  <div
    class="members"
    :class="{ 'search-open': searchWindowOpen, 'search-closed': !searchWindowOpen }"
  >
    <hr id="hr-search">
    <transition name="fade" appear>
      <div class="search-members" v-if="searchWindowOpen && activeTab === 1">

        <h3 class="search-members__title">
          {{ trans.get('pages:members.filters_panel.header') }}
        </h3>

        <div class="search-members__gender">
          <div class="gender">
            <div class="gender__item mb-0 mb-md-3 ">
              <div>
                <label>
                  <input
                    class="tgl tgl-light"
                    id="cb1"
                    type="checkbox"
                    v-model="form.genders"
                    value="female"
                  />
                  <label class="tgl-btn" for="cb1"></label>
                </label>
              </div>
              <div class="desc pb-2 pl-2">
                {{ trans.get('pages:members.filters_panel.show_girls') }}
              </div>
            </div>
            <div class="gender__item">
              <div>
                <label>
                  <input
                    class="tgl tgl-light"
                    id="cb2"
                    type="checkbox"
                    v-model="form.genders"
                    value="male"
                  />
                  <label class="tgl-btn" for="cb2"></label>
                </label>
              </div>
              <div class="desc pb-2 pl-2">
                {{ trans.get('pages:members.filters_panel.show_boys') }}
              </div>
            </div>
          </div>
        </div>

        <div class="search-members__settings">
          <div class="settings__location">
            <div class="form-group">
              <label class="desc">
                {{ trans.get('pages:members.filters_panel.location') }}
              </label>
              <div class="v-select-fill">
                <input-location-component
                  v-model="form.location_id"
                >
                </input-location-component>
              </div>
            </div>
          </div>
          <div class="settings__age">
            <div class="form-group">
              <label class="desc">
                {{ trans.get('pages:members.filters_panel.age') }}
              </label>
              <div class="vue-slider-in">
                <vue-slider
                  :value="[form.age_from, form.age_to]"
                  :min="18"
                  :max="99"
                  @change="form.age_from = $event[0]; form.age_to = $event[1]"
                ></vue-slider>
                <div class="vue-slider-in__number-range">{{ form.age_from }} -
                  {{ form.age_to }}
                </div>
              </div>
            </div>
          </div>
          <div class="settings__distance">
            <div class="form-group">
              <label class="desc">
                {{ trans.get('pages:members.filters_panel.distance') }}
              </label>
              <div class="vue-slider-in">
                <vue-slider
                  v-model="form.distance"
                  :min="5"
                  :max="500"
                  :marks="[5,50,95,140,185,230,275,320,365,410,455,500]"
                  :included="true"
                ></vue-slider>
                <div class="vue-slider-in__number-range">{{ form.distance }} km
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="search-members__icon">
          <i class="demo-icon icon-cards-icon"></i>
        </div>
        <div class="search-members__mobile-close">
          <button type="button" class="close" @click="searchWindowOpen = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </transition>

    <nav id="members__nav" class="members__nav">
      <a
        id="tab-neighbours"
        class="button button__tab-primary button__tab-primary button__tab-primary--left"
        :href="tabHash[1]"
        v-on:click="activeTab=1"
        v-bind:class="{'button__tab-primary--active': activeTab===1}"
      >
        {{ trans.get('pages:members.tabs.neighbours') }}
      </a>
      <a
        id="tab-visitors"
        class="button button__tab-primary button__tab-primary button__tab-primary--middle"
        :href="tabHash[2]"
        v-on:click="activeTab=2"
        v-bind:class="{'button__tab-primary--active': activeTab===2}"
      >
        {{ trans.get('pages:members.tabs.visitors') }}
        <unseen-visitor-count-component></unseen-visitor-count-component>
      </a>
      <a
        id="tab-top-choice"
        class="button button__tab-primary button__tab-primary button__tab-primary--right"
        :href="tabHash[3]"
        v-on:click="activeTab=3"
        v-bind:class="{'button__tab-primary--active': activeTab===3}"
      >
        {{ trans.get('pages:members.tabs.top_choice') }}
      </a>

      <button
        class="button button__tab button__search float-right"
        :class="{'button__search--open':searchWindowOpen }"
        v-if="activeTab === 1"
        @click="searchWindowOpen=!searchWindowOpen"
      >
        <i id="search-button-icon" class="demo-icon icon-search-l pr-1"></i>
        <span>{{ trans.get('pages:members.filters_panel.search_members_button') }}</span>
      </button>
    </nav>

    <div v-if="loadingPhotos" class="members__grid">

      <div v-for="index in 10" :key="index" class="members__profile">
        <div
          class="profile-card profile-card__image "
          style="background-color: #f5f5f5; width: 100%"
        >
          <div style="background-color: #ccc"></div>
        </div>
      </div>

    </div>
    <div
      v-show="!loadingPhotos"
      id="members-cards"
      class="members__grid"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="busy"
      infinite-scroll-distance="300"
    >
      <div :key="k" class="members__profile" v-for="(profile, k) in searchResults">
        <div class="profile-card ">
          <profile-card
            :profile="profile"
            :isVisitor="activeTab === 2"
            :isTopChoice="activeTab === 3"
            :isOther="false"
            @buy="openBuyModal"
          ></profile-card>
        </div>
      </div>
    </div>

    <div
      v-if="showMoreResults" id="more-results"
      class="row justify-content-center align-items-center my-3"
    >
      <div class="col">
        <hr>
      </div>
      <div class="col-auto desc desc--lightgrey">
        {{ trans.get('pages:members.filters_panel.other_profiles_label') }}
      </div>
      <div class="col">
        <hr>
      </div>
    </div>

    <div v-if="showMoreResults" class="members__grid">
      <div :key="k" class="members__profile" v-for="(profile, k) in otherProfilesResults">
        <div class="profile-card">
          <profile-card
            :profile="profile"
            :isTopChoice="activeTab === 3"
            :isOther="true"
            @buy="openBuyModal"
          ></profile-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SearchMixin from '../../../front/components/Members/SearchMixin';
import ProfileCard from './ProfileCard';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import UnseenVisitorCountComponent from './UnseenVisitorCountComponent';

var infiniteScroll = require('vue-infinite-scroll');

export default {
  name: 'SearchCard',
  components: { UnseenVisitorCountComponent, ProfileCard, VueSlider },
  directives: { infiniteScroll },
  mixins: [SearchMixin],
  methods: {},
};
</script>

<style scoped>

</style>
